<template lang="pug">
#top
  HamberguerMenu(class="navBar--isSp" @handleNavMenuVisible="toggleNavMenuVisible" :isMenuVisible="isVisibleNavMenu")
  Navbar(class="navBar--isPc" :pageSet="pageSet")
  NavMenu(v-if="isVisibleNavMenu" :pageSet="pageSet" @closeNavMenu="toggleNavMenuVisible")
  .contents
    TopBuildService
    approach
    //- TODO: CaseStudyのコメントアウトを外す場合は
    //-       components/atoms/SectionWrapper.vue のスタイルにあるコメントアウトを外す
    knowledge
    collaborator
    news
    recruit
</template>

<script>
import HamberguerMenu from './atoms/HamburgerMenu'
import Movie from './atoms/Movie'
import Navbar from './molecules/Navbar'
import NavMenu from './molecules/NavMenu'
import TopBuildService from './templates/top_build_service'
import corevalue from './templates/corevalue'
import approach from './templates/approach'
import recruit from './templates/recruit'
import knowledge from './templates/knowledge'
import collaborator from './templates/collaborator'
// newsの内容を更新したい場合は↓のファイル
import news from './templates/news'
import contact from './templates/contact'

export default {
  name: 'top',
  components: {
    HamberguerMenu,
    Movie,
    Navbar,
    NavMenu,
    TopBuildService,
    corevalue,
    approach,
    recruit,
    knowledge,
    collaborator,
    news,
    contact
  },
  data () {
    return {
      pageSet: [
        {
          path: '#build-service',
          alt: 'concept'
        },
        {
          path: '#approach',
          alt: 'approach'
        },
        {
          path: '#knowledge',
          alt: 'knowledge'
        },
        {
          path: '#collaborator',
          alt: 'collaborator'
        },
        {
          path: '#news',
          alt: 'news'
        },
        {
          path: '#recruit',
          alt: 'recruit'
        }
      ],
      isVisibleNavMenu: false
    }
  },
  methods: {
    toggleNavMenuVisible () {
      this.isVisibleNavMenu = !this.isVisibleNavMenu
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/stylesheets/variables';
@import '../assets/stylesheets/mixins';

.navBar {
  @media screen and (min-width: 1330px) {
    &--isPc {
      display: block;
    }
    &--isSp {
      display: none;
    }
  }
  @media screen and (max-width: 1329px) {
    &--isPc {
      display: none;
    }
    &--isSp {
      display: block;
    }
  }
}

.footer {
  @include bpOnlyPc() {
    flex-direction: row;
    justify-content: center;
  }
  @include bpOnlySp() {
    flex-direction: column;
    align-items: center;
  }
  display: flex;
  background: $buildNavy;
  color: $white;
  padding-bottom: 90px;
  font-size: 14px;
  font-weight: bold;
  &_link {
    @include bpOnlyPc() {
      margin-right: 60px;
    }
    @include bpOnlySp() {
      margin-bottom: 30px;
    }
    text-decoration: underline;
  }
}
</style>
